import { logToSentry } from "utils/networkErrorUtils";
import * as SlideActionTypes from "./actions";
import { apis } from 'utils/lib/apis';

export const handleCreateSlides = (payload) => async (dispatch) => {
  try {
    const res = await apis.post("booksRDS", `/ebook_ppt/create_book_slide`, {
      body: payload,
    });
    if (res?.data?.id) {
      await dispatch(SlideActionTypes.createSlides(res?.data));
    }
    return res?.data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'creating slides',
                error,
                module: 'SLIDES',
                operation: 'C_S'
            });
    }
  }
};

export const handleGetAllSlides = (bookId) => async (dispatch) => {
  try {
    const res = await apis.get(
      "booksRDS",
      `/ebook_ppt/get_book_slides/${bookId} `
    );
    if(res?.success){
      await dispatch(SlideActionTypes.getAllSlides(res?.data || []));
      return res?.data;
    }
    return [];
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'getting all slides',
                error,
                module: 'SLIDES',
                operation: 'G_A_S'
            });
    }
  }
};

export const handleDeleteSlide = (id) => async (dispatch) => {
  try {
    const res = await apis.del("booksRDS", `/ebook_ppt/delete_slide/${id}`);
    if (res?.data?.id) {
      await dispatch(SlideActionTypes.delteEbookSlide(id));
    }
    return res?.data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'deleting slide',
                error,
                module: 'SLIDES',
                operation: 'D_S'
            });
    }
  }
};

export const handleDeleteSlideImage = (payload) => async (dispatch) => {
  try {
    const { data } = await apis.put("booksRDS", `/ebook_ppt/delete_image`, {
      body: payload
    });

    if (data?.id) {
      await dispatch(SlideActionTypes.delteSlide(payload.slide_id));
      return data;
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'deleting slide image',
                error,
                module: 'SLIDES',
                operation: 'D_S_I'
            });
    }
  }
};

export const handleUpdateNotes = (payload) => async (dispatch) => {
  try {
    const { data } = await apis.put("booksRDS", `/ebook_ppt/update_notes`, {
      body: payload,
    });

    if (data?.id) {
      await dispatch(SlideActionTypes.setSlides(data));
      return data;
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'updating notes',
                error,
                module: 'SLIDES',
                operation: 'U_N'
            });
    }
  }
};

export const handleSwapOrder = (payload) => async (dispatch) => {
  try {
    const res = await apis.put("booksRDS", `/ebook_ppt/update_slides_order`, {
      body: payload,
    });

    if (res?.data?.id) {
      await dispatch(SlideActionTypes.setSlides(res?.data));
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'swapping order',
                error,
                module: 'SLIDES',
                operation: 'S_O'
            });
    }
  }
};

export const handleChangeImageUrl = (payload) => async (dispatch) => {
  try {
    const res = await apis.put("booksRDS", `/ebook_ppt/update_image_on_slide`, {
      body: payload,
    });

    if (res?.data?.id) {
      await dispatch(SlideActionTypes.setSlides(res?.data));
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'changing image url',
                error,
                module: 'SLIDES',
                operation: 'C_I_U'
            });
    }
  }
};

export const handleUpdateRectangle = (payload) => async (dispatch) => {
  try {
    const res = await apis.put("booksRDS", `/ebook_ppt/update_highlight`, {
      body: payload,
    });

    if (res?.data?.id) {
      await dispatch(SlideActionTypes.setSlides(res?.data));
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'updating rectangle',
                error,
                module: 'SLIDES',
                operation: 'U_R'
            });
    }
  }
};
